module.exports = __webpack_public_path__ + "img/ico_arrow_down.76d6def5.svg";